<h3>Customers <span class="highlight">(Click on a customer to edit)</span></h3>
<a routerLink="/addcustomer"  routerLinkActive="active"  class="btn btn-default">Add Customer</a>
<router-outlet />
<hr>
<div class="container divtable">
    <div class="divtablebody">
        <div class=" divrow">

            <div class="coltitle  appcol codecol-cust">Code</div>
            
            <div class="coltitle   appcol namecol-cust">Name</div>
            
            <div class="coltitle    appcol addresscol-cust">Address</div>
            
            <div class="coltitle    appcol phonecol-cust">Phone</div>

            <div class="coltitle    appcol btncol-cust">&nbsp;</div>
            <div class="coltitle     appcol btncol-cust">&nbsp;</div>
            
        </div>
        
        @for (customer of customers; track customer.id) {
        <div class=" divrow" (click)="onEdit(customer)">

            <div class=" appcol codecol-cust appcell">{{customer.customercode}}</div>
                    
            <div class=" appcol namecol-cust appcell">{{customer.customername}}</div>
                    
            <div class= "appcol addresscol-cust appcell">{{customer.addressline1 == null || customer.addressline1 == "" ? '&nbsp;' : customer.addressline1}}</div>
                    
            <div class=" appcol phonecol-cust appcell">{{customer.phone == null || customer.phone == ""? '&nbsp;' : customer.phone}}</div>

            <div class=" appcol btncol-cust">
              <button class="btn-xs btn-primary" (click)="onEditAddress(customer)">Addresses</button>   
            </div>
            <!--; $event.stopPropagation()-->
            <div class=" appcol btncol-cust">
              <button class="delete btn-xs btn-danger" (click)="deleteCustomer(customer); $event.stopPropagation()">Delete</button>    
            </div>
        </div>
        }
     </div>
    </div>
    

